export default __webpack_public_path__ + "static/media/Suyane_Mike_HickDuarte_33489.7f50c925.jpg";